<template>
    <div>
        <div class="text-tc-gray-3 text-22">{{campaign.name}}</div>
        <div class="flex items-center text-22">
            <div class="text-tc-gray-3">{{ campaign.pointType == 'get' ?  lbl.campaign.get :  lbl.campaign.use }}</div>
            <div class="text-tc-blue-1 px-1 font-main-bold" v-if="isCampaignDeal">{{ FilterNumberFormat(campaign.pricePerUnit) }}</div>
            <div class="text-tc-blue-1 px-1 font-main-bold" v-if="!isCampaignDeal">
                <span class="campaign-baht" v-if="isShowBaht">
                    ฿{{ FilterNumberFormat(campaign.maximumPartialPrice) }} + {{FilterNumberFormat(campaign.maximumPartialPoints ?? 0)}}
                </span>
                <span class="campaign-baht" v-if="!isShowBaht"> 
                    {{FilterNumberFormat(campaign.pointPerUnit ?? 0)}}
                </span> 
            </div>
            <div class="text-tc-gray-3 text-22" v-if="isCampaignDeal">บาท</div>
            <div v-else><img class="w-3" src="../../../assets/icon/icon-tipcoin.png"></div>
        </div>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { CampaignType } from "@/helper/StaticValue.js";

export default {
    name: "DetailInfo",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
        isCampaignDeal: { type: Boolean, default: false },
    },
    computed: {
        isShowBaht: function () {
            return (this.campaign.type ==   CampaignType.Privilege20);
        },
    },
    methods: {
        getPointTxt: function () {
            var pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var pointUnit = this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                        ? this.lbl.detail.point_unit + 's'
                        : this.lbl.detail.point_unit;

            return `${pointTypeTxt}${this.campaign.pointPerUnit} ${pointUnit}`;
        },
        agencyLogoUrl: function() {
            return ConfigManager.getBlobUrl() + "/agencies/" + this.campaign.agencyID;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
